// When content createors add content, the YouTube videos they
// may embed should be automatically responsive. This helper
// finds such content and polyfills responsivity to them.
//
// This is a very basic thing without any bells and whistles.
// Layout change? -> The height fix isn't called again.
// More content loaded? -> maxWidth isn't added to new elements
// These could be done if needed, but you need to then add
// listeners for that stuff, and rerun this function. Feel free to expand later.
const youtubeResponsifier = function() {
  const contentSelectors = [
    // Place here any content selector this fix should apply to.
    // This is a pretty limited whitelist. Add more selectors if needed,
    // just be aware there may be other embedded videos on the site.
    // Do you want this to apply to those too? If you wanted, this
    // could be just <body> and then apply to any youtube iframe.
    '.blog-container',
    '.heading-and-text',
    '.content',
  ];
  const youtubeIframeSelector = ' iframe[src^="https://www.youtube.com/"]';
  const contentYoutubeSelector = contentSelectors.map(s => `${s} ${youtubeIframeSelector}`).join(', ');
  document.querySelectorAll(contentYoutubeSelector).forEach(yt => {
    // 1) Set the maxWidth to make it adjust to container width.
    yt.style.maxWidth = '100%';

    // 2) Adjust the iframe height to match the current wdith. Not strictly necessary, but looks nicer.

    // Get the actual width of the youtube iframe.
    const ytStyle = window.getComputedStyle(yt);
    const width = parseInt(ytStyle.width);

    // Get width & height params for calculating aspect ratio. (Probably 16:9 but...)
    const heightAttr = parseInt(yt.getAttribute('height'));
    const widthAttribute = parseInt(yt.getAttribute('width'));
    // Make sure they aren't zero or something wacky
    if (heightAttr && !isNaN(heightAttr) && widthAttribute && !isNaN(widthAttribute)) {
      // Set the height proportional to width.
      yt.style.height = `${Math.ceil((width * heightAttr) / widthAttribute)}px`;
    }
    console.log('youtube-responsivity modified the embedded video.', yt);
  });
};
export default youtubeResponsifier;
